import { gql } from '@apollo/client';

export default gql`
  mutation UserDeleteRequest {
    userDeleteRequest(input: {}) {
      success
    }
  }
`;
